import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Button } from "../ui/button";
import { useAuth } from "../../context/AuthContext";

const PERKS = ["Track every application in one place", "Follow-up reminders", "Export to CSV, Excel or PDF"];

export const SignupCTA = ({ variant = "inline" }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const go = () => navigate(user ? "/dashboard" : "/register");

  if (variant === "inline") {
    return (
      <aside className="not-prose my-10 rounded-xl border border-[#E5E1DB] bg-white p-6 flex flex-col sm:flex-row sm:items-center gap-4 justify-between" data-testid="blog-inline-cta">
        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#C65D47]">Free tool</p>
          <p className="font-display text-lg mt-1">Put this into practice with Trackr. It's free.</p>
        </div>
        <Button onClick={go} className="rounded-full bg-[#1A362D] hover:bg-[#2C4A40] text-white px-5 shrink-0 active:scale-95 transition-transform" data-testid="blog-inline-cta-btn">
          {user ? "Open dashboard" : "Start tracking free"} <ArrowUpRight className="w-4 h-4 ml-1" />
        </Button>
      </aside>
    );
  }

  return (
    <section className="mt-16 rounded-2xl bg-[#1A362D] text-[#F4F1EE] p-8 sm:p-12 relative overflow-hidden" data-testid="blog-end-cta">
      <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-[#D99C3D]/20" />
      <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#D99C3D] relative">Your job search, organized</p>
      <h2 className="font-display text-3xl sm:text-4xl tracking-tight mt-3 relative max-w-xl">Stop losing track of applications.</h2>
      <ul className="mt-6 space-y-2 relative">
        {PERKS.map((p) => (
          <li key={p} className="flex items-center gap-2 text-sm text-[#F4F1EE]/85">
            <Check className="w-4 h-4 text-[#8B9D83]" /> {p}
          </li>
        ))}
      </ul>
      <Button onClick={go} className="mt-8 rounded-full bg-[#D99C3D] hover:bg-[#c98b2e] text-[#1A362D] px-6 relative active:scale-95 transition-transform" data-testid="blog-end-cta-btn">
        {user ? "Open your dashboard" : "Create your free account"} <ArrowUpRight className="w-4 h-4 ml-1" />
      </Button>
    </section>
  );
};
